<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex';
import ordersAPI from '../../api/orders';

export default {
  data: () => ({
    message: 'Error message',
  }),
  created() {
    this.setLoading(true);
    this.init();
  },
  methods: {
    ...mapActions({
      setLoading: 'SET_LOADING',
    }),

    init() {
      const { hash } = this.$route.params;

      if (!hash) {
        this.$router.push('/orders/list/current');
      }

      ordersAPI.acceptInvite(hash)
        .then((response) => {
          if (response.data.success) {
            this.$router.push(`/orders/details/${response.data.data.order_id}`);
          } else {
            this.$router.push('/orders/list/current');
          }
        });
    },

    close() {
      this.$router.push('/login').catch(() => {});
    },
  },
};
</script>
